import * as React from 'react';
import { Link } from 'react-router-dom';

import ImageHowto1PC from '@/assets/images/guide/img_keirin_howto_1_pc.png';
import ImageHowto1PCWebp from '@/assets/images/guide/img_keirin_howto_1_pc.png?webp';
import ImageHowto1PC2x from '@/assets/images/guide/img_keirin_howto_1_pc@2x.png';
import ImageHowto1PC2xWebp from '@/assets/images/guide/img_keirin_howto_1_pc@2x.png?webp';
import ImageHowto2PC from '@/assets/images/guide/img_keirin_howto_2_pc.png';
import ImageHowto2PCWebp from '@/assets/images/guide/img_keirin_howto_2_pc.png?webp';
import ImageHowto2PC2x from '@/assets/images/guide/img_keirin_howto_2_pc@2x.png';
import ImageHowto2PC2xWebp from '@/assets/images/guide/img_keirin_howto_2_pc@2x.png?webp';
import ImageHowto3PC from '@/assets/images/guide/img_keirin_howto_3_pc.png';
import ImageHowto3PCWebp from '@/assets/images/guide/img_keirin_howto_3_pc.png?webp';
import ImageHowto3PC2x from '@/assets/images/guide/img_keirin_howto_3_pc@2x.png';
import ImageHowto3PC2xWebp from '@/assets/images/guide/img_keirin_howto_3_pc@2x.png?webp';
import ImageHowto4aPC from '@/assets/images/guide/img_keirin_howto_4_1_pc.png';
import ImageHowto4aPCWebp from '@/assets/images/guide/img_keirin_howto_4_1_pc.png?webp';
import ImageHowto4aPC2x from '@/assets/images/guide/img_keirin_howto_4_1_pc@2x.png';
import ImageHowto4aPC2xWebp from '@/assets/images/guide/img_keirin_howto_4_1_pc@2x.png?webp';
import ImageHowto4bPC from '@/assets/images/guide/img_keirin_howto_4_2_pc.png';
import ImageHowto4bPCWebp from '@/assets/images/guide/img_keirin_howto_4_2_pc.png?webp';
import ImageHowto4bPC2x from '@/assets/images/guide/img_keirin_howto_4_2_pc@2x.png';
import ImageHowto4bPC2xWebp from '@/assets/images/guide/img_keirin_howto_4_2_pc@2x.png?webp';
import ImageHowto4cPC from '@/assets/images/guide/img_keirin_howto_4_3_pc.png';
import ImageHowto4cPCWebp from '@/assets/images/guide/img_keirin_howto_4_3_pc.png?webp';
import ImageHowto4cPC2x from '@/assets/images/guide/img_keirin_howto_4_3_pc@2x.png';
import ImageHowto4cPC2xWebp from '@/assets/images/guide/img_keirin_howto_4_3_pc@2x.png?webp';
import ImageHowto4dPC from '@/assets/images/guide/img_keirin_howto_4_4_pc.png';
import ImageHowto4dPCWebp from '@/assets/images/guide/img_keirin_howto_4_4_pc.png?webp';
import ImageHowto4dPC2x from '@/assets/images/guide/img_keirin_howto_4_4_pc@2x.png';
import ImageHowto4dPC2xWebp from '@/assets/images/guide/img_keirin_howto_4_4_pc@2x.png?webp';
import ImageStep1PC from '@/assets/images/guide/img_voting_race_pc_1.png';
import ImageStep1PCWebp from '@/assets/images/guide/img_voting_race_pc_1.png?webp';
import ImageStep1PC2x from '@/assets/images/guide/img_voting_race_pc_1@2x.png';
import ImageStep1PC2xWebp from '@/assets/images/guide/img_voting_race_pc_1@2x.png?webp';
import ImageStep2PC from '@/assets/images/guide/img_voting_race_pc_2.png';
import ImageStep2PCWebp from '@/assets/images/guide/img_voting_race_pc_2.png?webp';
import ImageStep2PC2x from '@/assets/images/guide/img_voting_race_pc_2@2x.png';
import ImageStep2PC2xWebp from '@/assets/images/guide/img_voting_race_pc_2@2x.png?webp';
import ImageStep3PC from '@/assets/images/guide/img_voting_race_pc_3.png';
import ImageStep3PCWebp from '@/assets/images/guide/img_voting_race_pc_3.png?webp';
import ImageStep3PC2x from '@/assets/images/guide/img_voting_race_pc_3@2x.png';
import ImageStep3PC2xWebp from '@/assets/images/guide/img_voting_race_pc_3@2x.png?webp';
import Break from '@/components/elements/Break';
import Button from '@/components/elements/Button/BaseButton';
import Image from '@/components/elements/Image';
import { HASH_RACE } from '@/components/templates/Top';

import {
  ButtonContainer,
  Text,
  TextNote,
  TitleSmall,
  TitleTertiary,
} from '../../style';
import VotingSingleStep, { StepDataType } from '../SingleStep';
import { HowtoImagePC, HowtoVote, Hr } from '../style';
import { VotingContentsProps } from '../type';

const stepData: StepDataType[] = [
  {
    image: (
      <Image
        srcSet={`${ImageStep1PC} 1x, ${ImageStep1PC2x} 2x`}
        mediaSet={[
          {
            srcSet: `${ImageStep1PCWebp} 1x, ${ImageStep1PC2xWebp} 2x`,
            type: 'image/webp',
          },
        ]}
        alt="レース情報画面イメージ"
        aspectRatio={231 / 640}
      />
    ),
    title: 'レース情報',
    text: '「出走表」や「直近成績」を見て予想！',
  },
  {
    image: (
      <Image
        srcSet={`${ImageStep2PC} 1x, ${ImageStep2PC2x} 2x`}
        mediaSet={[
          {
            srcSet: `${ImageStep2PCWebp} 1x, ${ImageStep2PC2xWebp} 2x`,
            type: 'image/webp',
          },
        ]}
        alt="投票選択画面イメージ"
        aspectRatio={231 / 640}
      />
    ),
    title: '投票選択',
    text: '賭式や車番を選択し、投票パネルへ追加！',
  },
  {
    image: (
      <Image
        srcSet={`${ImageStep3PC} 1x, ${ImageStep3PC2x} 2x`}
        mediaSet={[
          {
            srcSet: `${ImageStep3PCWebp} 1x, ${ImageStep3PC2xWebp} 2x`,
            type: 'image/webp',
          },
        ]}
        alt="投票パネル画面イメージ"
        aspectRatio={231 / 640}
      />
    ),
    title: '投票パネル',
    text: '投票内容を確認し、投票完了！',
  },
];

interface VotingSingleProps extends VotingContentsProps<HTMLDivElement> {}

const VotingSinglePC: React.FC<VotingSingleProps> = ({ refObj }) => {
  const VoteButton = (
    <ButtonContainer>
      <Link to={`/#${HASH_RACE}`}>
        <Button
          type="button"
          bgColor="primary"
          size="m"
          radius="l"
          height="56px"
          fontWeight="bold"
        >
          さっそく投票する！
        </Button>
      </Link>
    </ButtonContainer>
  );

  return (
    <div ref={refObj}>
      <TitleTertiary>パソコン</TitleTertiary>
      <TitleSmall>3ステップでカンタン投票！</TitleSmall>
      <VotingSingleStep data={stepData} />
      {VoteButton}
      <Hr />
      <TitleSmall>投票ページの使い方</TitleSmall>
      <Text>
        投票したいレースの「投票」ボタンをクリックすると投票ページへ移動します。
      </Text>
      <HowtoVote>
        <dt>1. 投票するレースと賭式の選択</dt>
        <dd>
          <Text>
            投票方法は<b>フォーメーション・BOX・流し・オッズ</b>
            からお好きな方法をお選びください。
            <br />
            賭式は複数選択することができます。
          </Text>
          <HowtoImagePC>
            <Image
              srcSet={`${ImageHowto1PC} 1x, ${ImageHowto1PC2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto1PCWebp} 1x, ${ImageHowto1PC2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票するレースと賭式の選択画面イメージ"
              width="100%"
              aspectRatio={489 / 1120}
            />
          </HowtoImagePC>
          <TextNote>
            <i>※</i>
            点線⋯競輪場や開催レースを変更したい場合は、こちらをクリックすると切り替えられます。
          </TextNote>
        </dd>
        <dt>2. 車番の選択</dt>
        <dd>
          <Text>
            投票したい選手の車番をクリックして選択します。もう一度クリックすると選択が解除されます。
            <br />
            全選択や全消去、マルチ投票の選択も可能です。
            <br />
            <Link to="/guide/racecard">出走表の見方はこちら</Link>
          </Text>
          <HowtoImagePC>
            <Image
              srcSet={`${ImageHowto2PC} 1x, ${ImageHowto2PC2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto2PCWebp} 1x, ${ImageHowto2PC2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="車番の選択画面イメージ"
              width="100%"
              aspectRatio={714 / 1120}
            />
          </HowtoImagePC>
        </dd>
        <dt>3. 投票パネルへ追加</dt>
        <dd>
          <Text>
            車番を選択すると、ページ右側に選択内容が表示され、票数の増減、買い目のオッズ確認や削除をすることができます。
            <Break breakpoint="large" isHidden />
            「投票パネルへ追加する」ボタンをクリックすると選択した買い目が投票パネルへ追加されます。
            <br />
            赤いバッジ内の数字は現在投票パネルに入っている組数です。
          </Text>
          <HowtoImagePC>
            <Image
              srcSet={`${ImageHowto3PC} 1x, ${ImageHowto3PC2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto3PCWebp} 1x, ${ImageHowto3PC2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票パネルへ追加画面イメージ"
              width="100%"
              aspectRatio={797 / 1120}
            />
          </HowtoImagePC>
          <Text>
            「投票パネル」では、現在投票パネルに追加されている買い目をいつでも確認することができます。
            <br />
            投票パネルへ追加が完了すると、選択した内容は投票選択画面からクリアされます。
            <br />
            続けて投票したい買い目がある場合はもう一度車番選択を行って投票パネルへ追加してください。
          </Text>
        </dd>
        <dt>4. 投票パネルで投票内容を確認して投票</dt>
        <dd>
          <Text>
            投票したい買い目をすべて投票パネルへ追加したら、「投票パネル」ボタンをタップして開きます。
            <br />
            投票パネルへ追加されている買い目が表示され、買い目の修正や削除、口数変更や資金配分が行えます。資金配分は全ての買い目に対してまとめて行うこと可能です。
            <br />
            投票する組番が決まったら「投票確認へ」ボタンをタップします。
          </Text>
          <HowtoImagePC>
            <Image
              srcSet={`${ImageHowto4aPC} 1x, ${ImageHowto4aPC2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto4aPCWebp} 1x, ${ImageHowto4aPC2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票パネル、投票確認へボタン画面イメージ"
              width="100%"
              aspectRatio={714 / 1120}
            />
          </HowtoImagePC>
          <Text>
            投票内容・組数・投票金額をよく確認します。
            <br />
            投票内容を修正したい場合は「キャンセル」ボタンをクリックすれば先程の投票パネルへ戻ります。
            <br />
            「確定する」ボタンをクリックすると、投票が確定します。
          </Text>
          <TextNote>
            <i>※</i>
            投票が確定すると変更や取り消しはできませんのでご注意ください。
          </TextNote>
          <HowtoImagePC>
            <Image
              srcSet={`${ImageHowto4bPC} 1x, ${ImageHowto4bPC2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto4bPCWebp} 1x, ${ImageHowto4bPC2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票パネル、確定するボタン画面イメージ"
              width="100%"
              aspectRatio={714 / 1120}
            />
          </HowtoImagePC>
          <Text>
            「投票が完了しました」と表示されれば無事投票完了です！
            <br />
            開催中の他のレースを続けて投票することもできます。
          </Text>
          <HowtoImagePC>
            <Image
              srcSet={`${ImageHowto4cPC} 1x, ${ImageHowto4cPC2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto4cPCWebp} 1x, ${ImageHowto4cPC2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票パネル、投票完了画面イメージ"
              width="100%"
              aspectRatio={489 / 1120}
            />
          </HowtoImagePC>
          <Text>
            投票パネルを閉じ、投票画面の「購入車券」ボタンをクリックすると、投票が完了した組番・オッズ・投票金額などの情報がご確認いただけます。
          </Text>
          <HowtoImagePC>
            <Image
              srcSet={`${ImageHowto4dPC} 1x, ${ImageHowto4dPC2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto4dPCWebp} 1x, ${ImageHowto4dPC2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="購入車券画面イメージ"
              width="100%"
              aspectRatio={489 / 1120}
            />
          </HowtoImagePC>
        </dd>
      </HowtoVote>
      {VoteButton}
    </div>
  );
};

export default VotingSinglePC;
